import React, { useContext, useState } from 'react'

const TranslationContext = React.createContext();
const TranslationUpdateContext = React.createContext();

// Custom hook to give easy access 
export function useTranslation(){
    return useContext(TranslationContext)
}
// Custom hook to give easy access 
export function useTranslationUpdate(){
    return useContext(TranslationUpdateContext)
}

export function TranslationProvider({ children }){
    // School Document and Evaluations needs to be implemented from their components to this
    const [qbData, setQbData] = useState({
      translationRunOnce: false,

      translationTypes: [],
      iepText: '',
      iep_checked: '',
      transcriptText: '',
      transcript_checked: '',
      letterText: '',
      letter_checked: '',
      schoolDocumentText: '',
      schoolDocument_checked: '',
      calendarText: '',
      calendar_checked: '',
      flyerText: '',
      flyer_checked: '',
      handbookText: '',
      handbook_checked: '',
      healthFormsText: '',
      healthForms_checked: '',
      permissionSlipText: '',
      permissionSlip_checked: '',
      schedulesText: '',
      schedules_checked: '',
      evaluationsText: '',
      evaluations_checked: '',
      psychological_checked: '',
      educational_checked: '',
      socialHistory_checked: '',
      speechLanguage_checked: '',
      otherLanguageText: '',
      other_checked: '',
      otherText: '',
      dueDateText: '',
      districtDropdown: '',
      districtRid: 0,
      schoolDropdown: '',
      schoolRid: 0,
      languageDropdown: '',
      contactNameText: '',
      contactPhoneText: '',
      contactEmailText: '',
      approverNameText: '',
      approverPositionText: '',
      approverEmailText: '',
      coser: '',

      docToTranslateFiles: [],

      intakeRunOnce: false,

      dueDate_int: '',
      dueTime_int: '',
      interpretationTypes_int: [],
      testingSubject_int: '',
      estimatedDurationHrs_int: '',
      estimatedDurationMins_int: '',
      paperWorkChecked_int: '',
      needInterpreterChecked_int: '',
      inPersonMeetingChecked_int: '',
      teleconference_int: '',
      teleconferencePhone_int: '',
      onlineOrVirtChecked_int: '',
      onlineMeetingLink_int: '',
      studentName_int: '',
      phone_int: '',
      grade_int: '',
      gender_int: '',
      languageDropdown_int: '',
      otherLanguages_int: '',
      districtDropdown_int: '',
      schoolDropdown_int: 0,
      address_int: '',
      contactName_int: '',
      contactPhone_int: '',
      contactEmail_int: '',
      approverName_int: '',
      approverPosition_int: '',
      approverEmail_int: '',
      districtRid_int: 0,
      schoolRid_int: 0,
      approverSignatureFile_int: '',
      tableData_int: [],
      notes_int: '',
      coser_int: '',

      docToInterperateFiles_int: [],

      assessmentRunOnce: false,
      assessmentApprovalRunOnce: false,
      
      studentFirstName_bil: '',
      studentLastName_bil: '',
      countryOfOrigin_bil: '',
      DOB_bil: '',
      gender_bil: '',
      yearsInUS_bil: '',
      grade_bil: '',
      childResidesWith_bil: '',
      mfg1_bil: '',
      mfgName1_bil: '',
      mfg2_bil: '',
      mfgName2_bil: '',
      childsResidesWithOther_bil: '',
      homeAddress_bil: '',
      homeNum_bil: '',
      workNum_bil: '',
      cellNum_bil: '',
      nativeLanguage_bil: '',
      nativeLanguageOther_bil: '',
      districtDropdown_bil: '',
      schoolDropdown_bil: '',
      CSEDate_bil: '',
      currentTeacherName_bil: '',
      currentTeacherEmail_bil: '',
      psychologistName_bil: '',
      psychologistEmail_bil: '',
      speechPathologistName_bil: '',
      speechPathologistEmail_bil: '',
      districtContactName_bil: '',
      districtContactTitle_bil: '',
      districtContactAddress_bil: '',
      districtContactPhone_bil: '',
      districtContactEmail_bil: '',
      approverName_bil: '',
      approverTitle_bil: '',
      approverEmail_bil: '',
      coser_bil: '',

      reason_bil: '',
      alreadyClassified_bil: '',
      classification_bil: '',

      consentToEvalAttached_bill: false,
      priorWrittenNoticeAttached_bil: false,
      homeLangQuestAttached_bil: false,
      nonVerbSecDiagnosed_bil: false,
      
      studentEnterSchoolDate_bil: '',
      nameOfOtherSchoolAttended_bil: '',
      typesOfEvals_bil: [],
      typesOfEvals_other_bil: [],
      diagnosedCondition_bil: '',
      diagnosedConditionText_bil: '',
      services_bil: [],
      generalHealth_bil: false,
      generalHealthText_bil: '',
      medication_bil: false,
      medicationText_bil: '',
      wearsGlasses_bil: false,
      wearsGlassesText_bil: '',
      pedRestrictions_bil: false,
      pedRestrictionsText_bil: '',
      physicalExamDate_bil: '',
      h_freq_audiology_bil: '',
      h_indv_audiology_bil: '',
      h_freq_visTherapy_bil: '',
      h_indv_visTherapy_bil: '',
      h_freq_resourceRoom_bil: '',
      h_indv_resourceRoom_bil: '',
      h_freq_counseling_bil: '',
      h_indv_counseling_bil: '',
      h_freq_speechLang_bil: '',
      h_indv_speechLang_bil: '',
      h_freq_physTherapy_bil: '',
      h_indv_physTherapy_bil: '',
      h_freq_occTherapy_bil: '',
      h_indv_occTherapy_bil: '',
      i_freq_Reading_bil: '',
      i_indv_Reading_bil: '',
      i_freq_AISMath_bil: '',
      i_indv_AISMath_bil: '',
      i_freq_AAtL_bil: '',
      i_indv_AAtL_bil: '',
      i_freq_AdjAssign_bil: '',
      i_indv_AdjAssign_bil: '',
      i_freq_schedAdj_bil: '',
      i_indv_schedAdj_bil: '',
      i_freq_indvProgBasedOnSkill_bil: '',
      i_indv_indvProgBasedOnSkill_bil: '',
      i_freq_speechImprov_bil: '',
      i_indv_speechImprov_bil: '',
      i_freq_tutoring_bil: '',
      i_indv_tutoring_bil: '',
      i_freq_consulServices_bil: '',
      i_indv_consulServices_bil: '',
      i_other_bil: '',
      areas_bil: [],
      addConcerns_bil: '',
      suspDetails_bil: '',
      notes_bil: '',

      docToAccessFiles_bil: [],
      consentToEvalAttachedFiles_bil: [],
      priorWrittenNoticeAttachedFiles_bil: [],
      homeLangQuestAttachedFiles_bil: []
    })

    function changeQbData(){
        
    }

    return(
        <TranslationContext.Provider value={qbData}>
            <TranslationUpdateContext.Provider value={changeQbData}>
                {children}
            </TranslationUpdateContext.Provider>
        </TranslationContext.Provider>
    )
}

